import React from 'react';
import { Button } from 'antd';

export default function AntButton(props) {
  return <Button {...props} />;
}
